/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconEqual = createReactComponent("equal", "IconEqual", [
  ["path", { d: "M5 10h14", key: "svg-0" }],
  ["path", { d: "M5 14h14", key: "svg-1" }]
]);

export { IconEqual as default };
//# sourceMappingURL=IconEqual.js.map
